<!-- EDS HEADER -->
<div [ngClass]="{ 'has-edit-button': isEditMode }">
  <ng-container [brManageMenuButton]="menuModel"></ng-container>

  <ng-container [ngSwitch]="headerStyle">
    <eds-header
      *ngSwitchCase="'basic'"
      [hasUpliftStyling]="hasUpliftStyling"
      [isUpliftFeature]="isUpliftFeature"
      [hasLanguageMenu]="langItems?.length > 0"
      [langTitle]="languageLabel"
      [langItems]="langItems"
      [logoImgSrc]="headerContent?.logoImage || headerLogo"
      [logoMobImgSrc]="
        headerContent?.logoImage || mobileHeaderLogo || headerLogo
      "
      [logoAltText]="headerContent?.logoAlt || logoAltText"
      [logoHref]="homeUrl"
      [hasLogoLink]="false"
      [hasWideLogo]="hasWideLogo"
      [isMicrosite]="isMicrosite"
      [hasTextLogo]="micrositeTextLogo"
      [micrositeTextLogo]="micrositeTextLogo"
      [micrositeLogoHref]="micrositeLogoHref"
      [hasGlobalNav]="false"
      [hasSiteNav]="false"
      [hasNavigation]="true"
      [screenReaderSignInButtonText]="'signin.signIn' | translate"
      [screenReaderSignOutButtonText]="'signin.signOutMobile' | translate"
      [screenReaderSearchBtn]="'signin.search' | translate"
      [screenReaderNavToggleBtn]="'signin.screenReaderNavToggleBtn' | translate"
      [smallHeader]="true"
      [countryHub]="countryHub"
      [hasMaskedIcon]="true"
      [isSearchActive]="isSearchActive"
      (searchClosed)="clearSearchResults()"
      [skipTo]="skipLinkPath"
      [skipToText]="'common.skip-to-content' | translate"
      (onSkipTo)="onSkipToEvent(true)"
      [isCustomMegaMenu]="isCustomMegaMenu"
    >
    </eds-header>
    <!-- Unidentified Gateway User-->
    <eds-header
      *ngSwitchCase="'basic-with-login'"
      [hasUpliftStyling]="hasUpliftStyling"
      [isUpliftFeature]="isUpliftFeature"
      [hasLanguageMenu]="langItems?.length > 0"
      [langTitle]="languageLabel"
      [langItems]="langItems"
      [logoImgSrc]="headerContent?.logoImage || headerLogo"
      [logoMobImgSrc]="
        headerContent?.logoImage || mobileHeaderLogo || headerLogo
      "
      [logoAltText]="headerContent?.logoAlt || logoAltText"
      [logoHref]="homeUrl"
      [hasLogoLink]="false"
      [hasWideLogo]="hasWideLogo"
      [hasGlobalNav]="true"
      [hasSiteNav]="false"
      [hasNavigation]="true"
      [signInIsDisabled]="isSubmitButtonDisabled"
      [hasSignInBtn]="true"
      [customSignInToggle]="customSignInToggle"
      [signInNotification]="signInNotification"
      [showLegacySignInOption]="showLegacySignInOption"
      [showLegacyContent]="showLegacyContent"
      [isLogIn]="isLogIn"
      [screenReaderSignInButtonText]="'signin.signIn' | translate"
      [screenReaderSignOutButtonText]="'signin.signOutMobile' | translate"
      [selectedRole]="currentSegmentLabel"
      [signInNavData]="signInNavItems"
      [signInComponentContent]="signInComponentContent"
      [signInText]="'signin.signInRegister' | translate"
      [signOutText]="'signin.signOut' | translate"
      [signInFormAction]="signInFormAction"
      [signInHiddenInputs]="signInHiddenInputs"
      (onSignIn)="onSubmit($event)"
      (onSignInMenuClick)="onSignInMenuClick($event)"
      [smallHeader]="true"
      [countryHub]="countryHub"
      [hasMaskedIcon]="true"
      [showMaskedText]="'signin.show' | translate"
      [hideMaskedText]="'signin.hide' | translate"
      [isSearchActive]="isSearchActive"
      (searchClosed)="clearSearchResults()"
      [skipTo]="skipLinkPath"
      [skipToText]="'common.skip-to-content' | translate"
      (onSkipTo)="onSkipToEvent(true)"
      (fastTrackRegistrationClick)="fastTrackRegistration()"
      (legacyBtnEmiter)="legacyBtnclick($event)"
      [isCustomMegaMenu]="isCustomMegaMenu"
    >
    </eds-header>
    <eds-header
      *ngSwitchDefault
      [hasUpliftStyling]="hasUpliftStyling"
      [isUpliftFeature]="isUpliftFeature"
      [hasLanguageMenu]="langItems?.length > 0"
      [langTitle]="languageLabel"
      [langItems]="langItems"
      [hasGlobalNav]="
        globalItems?.length > 0 || accountsNav?.length > 0 || hasSignInBtn
      "
      [globalNavItems]="globalItems"
      [hasSiteNav]="siteNavData?.length > 0"
      [hasNavigation]="hasNavigation"
      [siteNavData]="siteNavData"
      [logoImgSrc]="headerContent?.logoImage || headerLogo"
      [logoMobImgSrc]="
        headerContent?.logoImage || mobileHeaderLogo || headerLogo
      "
      [logoAltText]="headerContent?.logoAlt || logoAltText"
      [logoHref]="homeUrl"
      [hasLogoLink]="hasLogoLink"
      [hasWideLogo]="hasWideLogo"
      [hasFirmBrandedLogo]="hasFirmBrandedLogo"
      [isMicrosite]="isMicrosite"
      [hasTextLogo]="micrositeTextLogo"
      [micrositeTextLogo]="micrositeTextLogo"
      [micrositeLogoHref]="micrositeLogoHref"
      [hasSignInBtn]="hasSignInBtn"
      [customSignInToggle]="customSignInToggle"
      [signInNotification]="signInNotification"
      [showLegacySignInOption]="showLegacySignInOption"
      [showLegacyContent]="showLegacyContent"
      [isLogIn]="isLogIn"
      [screenReaderSignInButtonText]="'signin.signIn' | translate"
      [screenReaderSignOutButtonText]="'signin.signOutMobile' | translate"
      [signInNavData]="signInNavItems"
      [hasAccountsFlyoutNav]="accountsNav.length > 0"
      [accountsNav]="accountsNav"
      [accountsNavName]="accountsNavName"
      [hasSignInFlyoutNav]="signedInUserNav.length > 0"
      [signedInUserName]="signedInUserName"
      [signedInUserNav]="signedInUserNav"
      [signInComponentContent]="signInComponentContent"
      [signInText]="'signin.signInRegister' | translate"
      [signOutText]="'signin.signOut' | translate"
      [signInFormAction]="signInFormAction"
      [signInHiddenInputs]="signInHiddenInputs"
      [hasSearch]="hasSearch"
      [searchLabel]="'signin.search' | translate"
      [searchPlaceholder]="
        headerContent?.headerSearchBoxLabelOverride ||
        ('common.search.placeholder-mobile' | translate)
      "
      [searchClearText]="'common.search.clear' | translate"
      [searchFieldId]="searchFieldId"
      [selectedRole]="currentSegmentLabel"
      [signinId]="'signInID'"
      [cartCount]="cartSize"
      [screenReaderSearchBtn]="'signin.search' | translate"
      [screenReaderNavToggleBtn]="'signin.screenReaderNavToggleBtn' | translate"
      [signInIsDisabled]="isSubmitButtonDisabled"
      (onSignIn)="onSubmit($event)"
      (onSignOut)="signOut()"
      (onSignInMenuClick)="onSignInMenuClick($event)"
      (showRoleSelectorDialog)="showRoleSelectorDialog()"
      [smallHeader]="siteNavData?.length === 0"
      [hasMaskedIcon]="true"
      [showMaskedText]="'signin.hide' | translate"
      [hideMaskedText]="'signin.show' | translate"
      [isSearchActive]="isSearchActive"
      (searchClosed)="clearSearchResults()"
      [skipTo]="skipLinkPath"
      [skipToText]="'common.skip-to-content' | translate"
      (onSkipTo)="onSkipToEvent(true)"
      (fastTrackRegistrationClick)="fastTrackRegistration()"
      (legacyBtnEmiter)="legacyBtnclick($event)"
      [isCustomMegaMenu]="isCustomMegaMenu"
      [shouldHideMyFundLogin]="shouldHideMyFundLogin"
    ></eds-header>
  </ng-container>
</div>
<!-- /EDS HEADER TO COME-->
<ft-search
  *ngIf="hasSearch && !searchConfig.enableSearchPage"
  [headerStyle]="headerStyle"
  [searchPlaceholderText]="
    (isHandheld$ | async) !== true
      ? headerContent?.searchModalBoxLabelOverride
      : headerContent?.headerSearchBoxLabelOverride
  "
  (isSearchActive)="setSearchButton($event)"
  id="ftSearch"
></ft-search>
